<template>
  <b-card class="m-3" no-body>
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">
          Detalhes de Entrega de Legislação
        </span>
        <btn-voltar url="/entrega/legislacoes" />
      </h6>
    </template>
    <b-card-body>
      <b-row class="text-justify mb-3" v-if="entrega">
        <b-col cols="6" md="2">
          <b-form-group label-class="font-weight-bold pt-0" label="ID">
            <span>{{ entrega.Legislacao?.IdEntrega }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="6" md="2">
          <b-form-group label-class="font-weight-bold pt-0" label="Situação">
            <span>{{ getDescSituacao(entrega.Legislacao?.Situacao) }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label-class="font-weight-bold pt-0" label="Data de Entrega">
            <span>{{ formatarData(entrega.Legislacao?.DataEntrega) }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="6" md="2">
          <b-form-group label-class="font-weight-bold pt-0" label="Exercício">
            <span>{{ entrega?.Legislacao?.Exercicio }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label-class="font-weight-bold pt-0" label="Tipo de Entrega">
            <span>{{ entrega.Legislacao?.TipoEntrega?.Descricao }}</span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="entrega.Legislacao?.Documentos" sort-by="" 
        :sort-desc="true" striped stacked="md" show-empty>
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(NroAno)="row">
          <div>
            <span>{{row.item.Numero + "/" + row.item.Ano}}</span>
          </div>
        </template>
        <template v-slot:cell(demais)="row">
          <div>

            <div v-if = "entrega.TipoUg === 'prefeitura' && entrega.Legislacao.TipoEntrega.Sigla === 'FS'">
              Valor Fixado Prefeito: {{formatMoeda(row.item.VlPrefeito)}}
              <br>
              Valor Fixado Vice-Prefeito: {{formatMoeda(row.item.VlVicePrefeito)}}
            </div>
            <div v-if = "entrega.TipoUg === 'camara' && entrega.Legislacao.TipoEntrega.Sigla === 'FS'">
              Valor Fixado Vereador: {{formatMoeda(row.item.VlVereador)}}
              <br>
              Qtd de vereadores: {{row.item.QtdVereadores}}
            </div>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="actions-icons">
            <btn-download :fazerDownload="baixarDocumento" :parametros="row.item" />
          </div>
        </template>
      </b-table>

    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { store } from "@/store";
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from "@/components/shared/btn-download.vue";
import legislacaoService from '@/services/entregas/legislacaoService';
import { TableField } from '@/types/table-field';
import { fieldsDocumento } from '@/types/entregas/legislacao/fields-documento';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';


const CompProps = Vue.extend({
  name: 'DetalhesLegislacao',
  components: { BtnVoltar, BtnDownload },
  props: {
    idEntrega: {
      type: String
    }
  },
})

@Component
export default class DetalhesLegislacao extends mixins(UtilsTS, CompProps) {
  entrega: any = {}
  tableBusy = false
  fields: TableField[] = fieldsDocumento

  async mounted() {
    try {
      this.tableBusy = true
      store.blockScreen = true
      this.entrega = await legislacaoService.getLegislacaoById(Number(this.idEntrega))
    } catch (e: any) {
      this.tratarError(e)
      this.$router.push('/entrega/legislacoes');
    } finally {
      store.blockScreen = false
      this.tableBusy = false
    }
  }

  formatarData(sData){
    return new Date(sData).toLocaleDateString()
  }

  getDescSituacao(situacao) {
    if (situacao == 'E') return 'Entregue'
    if (situacao == 'C') return 'Cancelada'
    if (situacao == 'M') return 'Em Andamento'
    return situacao
  }

  async baixarDocumento(documento) {
    const arq = await legislacaoService.downloadDocumento(documento.IdDocumento)
    this.download(`${documento.Nome ?? 'documento'}.pdf`, arq)
  }
}

</script>

